/**
 * AdminSearchInput — Uniforme zoekbalk voor admin listings.
 *
 * Vervangt de losse Search icon + Input combinaties in
 * DebiteurenDashboard, BetalingsregelingenSection, RemindersSection.
 */
import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "../../ui/input";

export default function AdminSearchInput({
  value,
  onChange,
  placeholder = "Zoeken…",
  width = "w-72",
  testid = "admin-search",
  onClear,
}) {
  const handleClear = () => {
    onChange({ target: { value: "" } });
    onClear?.();
  };
  return (
    <div className={`relative ${width}`}>
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-400 pointer-events-none" />
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="pl-9 pr-9 h-10 rounded-full border-slate-200 focus-visible:ring-brand-500/20 focus-visible:border-brand-500"
        data-testid={testid}
      />
      {value ? (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-ink-400 hover:text-brand-900 p-1 rounded-full hover:bg-slate-100"
          aria-label="Zoekterm wissen"
          data-testid={`${testid}-clear`}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      ) : null}
    </div>
  );
}
